// extracted by mini-css-extract-plugin
export var headerCell = "_4t-1";
export var loadingStateCell = "_4t-4";
export var rowWrapper = "_4t-3";
export var standaloneTable = "_4t-5";
export var table = "_4t-0";
export var white = "_4t-2";